import { Controller } from "@hotwired/stimulus";
import { useIntersection } from 'stimulus-use'
import fitty from "fitty";

export default class extends Controller {
    static values = {
        minSize: {
            type: Number,
            default: 16,
        },
        maxSize: {
            type: Number,
            default: 512,
        },
        multiLine: {
            type: Boolean,
            default: true,
        },
    }

    fitty

    connect() {
        if (this.watch) {
            useIntersection(this)
        } else {
            this.fitty = fitty(this.element, {
                minSize: this.minSizeValue,
                maxSize: this.maxSizeValue,
                multiLine: this.multiLineValue,
            })
        }
    }
    
    appear() {
        this.fitty = fitty(this.element, {
            minSize: this.minSizeValue,
            maxSize: this.maxSizeValue,
            multiLine: this.multiLineValue,
        })
    }

    disappear() {
        this.fitty?.unsubscribe()
        this.fitty = null
    }

    disconnect() {
        this.fitty?.unsubscribe()
    }

    get watch () {
        return this.data.has('watch')
    }
}
